import Repository from './repository';

const resource = '/triggers';
export default {
	findSegments(payload) {
		return Repository.postWithAuth(`${resource}/segments/find`, payload);
	},
	findSegmentConstant(payload) {
		return Repository.getWithAuth(`${resource}/constants/find`, payload);
	},
	findTriggersByMerchantID(payload) {
		return Repository.postWithAuth(`${resource}/find`, payload);
	},
	getTriggerById(trigger_id, merchant_id) {
		return Repository.getWithAuth(
			`${resource}/find/${trigger_id}/${merchant_id}`
		);
	},
	createTrigger(payload) {
		return Repository.postWithAuth(
			`${resource}`,
			payload,
			{},
			{ noCache: true }
		);
	},
	updateTrigger(trigger_id, payload) {
		return Repository.putWithAuth(`${resource}/${trigger_id}`, payload);
	},
	deleteTrigger(trigger_id, payload) {
		return Repository.deleteWithAuth(`${resource}/${trigger_id}`, payload);
	},
	createTriggerEvent(trigger_id, payload) {
		return Repository.postWithAuth(`${resource}/${trigger_id}/events`, payload);
	},
	updateTriggerEvent(event_id, payload) {
		return Repository.putWithAuth(`${resource}/events/${event_id}`, payload);
	},
	deleteTriggerEvent(event_id, payload) {
		return Repository.deleteWithAuth(`${resource}/events/${event_id}`, payload);
	},
	loadTriggerEvents(event_id, payload) {
		return Repository.postWithAuth(
			`${resource}/events/find/${event_id}`,
			payload
		);
	},
	updateStatus(trigger_id, payload) {
		return Repository.putWithAuth(`${resource}/${trigger_id}/status`, payload);
	},
};
